<template>
  <div class="d-flex justify-center contents">
    <template v-if="this.target != null">
      <div :type="this.attribute" class="arrow"><span class="content">1. 属性選択</span></div>
      <div :type="this.subject" class="arrow"><span class="content">2. 科目選択</span></div>
      <div :type="this.favorite" class="arrow"><span></span><br><span class="content">3. マッチング結果</span><br><span class="font_small">（キーワード選択）</span></div>
      </template>
      <template v-else>
        <div :type="this.attribute" class="arrow"><span class="content">1. 属性選択</span></div>
        <div :type="this.favorite" class="arrow"><span></span><br><span class="content">2. マッチング結果</span><br><span class="font_small">（キーワード選択）</span></div>
      </template>
    </div>
</template>
<script>
export default {
  props: ['target', 'page'],
  data() {
    return {
      attribute: false,
      subject: false,
      favorite: false,
    }
  },
  created() {
    if(this.page == "attribute"){
      this.attribute = true;
    }
    else if(this.page == "subject"){
      this.subject = true;
    }else if(this.page == "favorite"){
      this.favorite = true;
    }
  }
}
</script>
<style scoped>
.contents {
  margin: 16px;
}
.arrow {
  display: grid;
  align-content: space-around;
  place-items: start start;
  margin-right: 16px;
  padding-left: 2.67vw;
  background: #DDD;
  color: #000;
  width: 25.5vw;
	height: 10vw;
  line-height: 0%;
  -webkit-clip-path: polygon(0% 0%, 85% 0%, 100% 50%, 85% 100%, 0% 100%);
  clip-path: polygon(0% 0%, 85% 0%, 100% 50%, 85% 100%, 0% 100%);
}
.arrow[type="true"] {
  background: #00a0e9;
  color: white;
  font-weight: bold;
}
.font_small {
  font-size: 1.56vw;
  text-indent: 1em;
  margin-top: -1.78vw;
}
.content {
  font-size: 2.2vw;
  margin: -0.67vw 0;
}
@media (min-width: 450px) {
  .contents {
    margin: 32px 16px;
  }
}
@media (min-width: 960px) {
  .contents {
    margin: 32px;
  }
  .arrow {
    width: 230px;
    height: 80px;
    padding-left: 24px;
  }
  .content {
    font-size: 20px;
    margin: -2px 0;
  }
  .font_small {
    font-size: 14px;
    margin-top: -12px;
  }
}
</style>